module.exports = __webpack_public_path__ + "img/zhijvyun3en.ac46210b.jpg";